import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, provide, inject } from 'intact-react';
import template from './menu.vdt';
import { useHighlight } from './useHighlight';
import { useConfigContext } from '../config';
import { bind } from '../utils';
var typeDefs = {
  expandedKeys: Array,
  selectedKey: [String, Number],
  theme: ['light', 'dark', 'white'],
  collapse: Boolean,
  showCollapseArrow: Boolean,
  type: ['vertical', 'horizontal'],
  size: ['large', 'default', 'small'],
  accordion: Boolean,
  dot: Boolean,
  _paddingLeft: String
};
var defaults = function defaults() {
  return {
    expandedKeys: [],
    theme: 'dark',
    type: 'vertical',
    size: 'default'
  };
};
export var MENU = 'Menu';
export var ROOT_MENU = 'RootMenu';
export var Menu = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Menu, _Component);
  function Menu() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.rootMenu = inject(ROOT_MENU, null);
    _this.parentMenu = inject(MENU, null);
    _this.subExpandedKeys = void 0;
    _this.highlight = void 0;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Menu.prototype;
  _proto.init = function init() {
    provide(MENU, this);
    // is root menu or not
    if (!this.rootMenu) {
      provide(ROOT_MENU, this);
      this.highlight = useHighlight();
    }
  };
  _proto.onClick = function onClick(e) {
    var _this$get = this.get(),
      collapse = _this$get.collapse;
    this.set({
      collapse: !collapse
    });
  };
  return Menu;
}(Component);
Menu.template = template;
Menu.typeDefs = typeDefs;
Menu.defaults = defaults;
__decorate([bind], Menu.prototype, "onClick", null);